import { uniqueInArray } from 'utils/functional';
import React from 'react';
import PropTypes from 'prop-types';

import StopCard from 'modules/Stop/Card';

import { StyledRowContainer } from './styled';

export const stopsHasDifferentCountries = (stops) => {
  const uniqueCountryStops = (stops || [])
    .map((stop) => stop?.address?.country)
    .filter(uniqueInArray);

  return uniqueCountryStops.length > 1;
};

const StopCards = React.memo(
  ({
    onUploadCargoManifestClick,
    onDeleteCargoManifestClick,
    onUpdateStopTimes,
    item,
    shipperOrdersSkin,
    updatingTimes,
  }) => (
    <StyledRowContainer>
      {(item.stops || []).map((stop, key) => (
        <StopCard
          key={key}
          item={item}
          stop={stop}
          showCountry={stopsHasDifferentCountries(item.stops)}
          stops={item.stops}
          onUploadClick={onUploadCargoManifestClick}
          onDeleteClick={onDeleteCargoManifestClick}
          onUpdateTimesClick={onUpdateStopTimes}
          updatingTimes={updatingTimes}
          stopId={key}
          shipperOrdersSkin={shipperOrdersSkin}
          displayJourney={item.journeys}
        />
      ))}
    </StyledRowContainer>
  )
);

StopCards.propTypes = {
  onUploadCargoManifestClick: PropTypes.func,
  onDeleteCargoManifestClick: PropTypes.func,
  onUpdateStopTimes: PropTypes.func,
  updatingTimes: PropTypes.bool,
  item: PropTypes.shape({}),
  shipperOrdersSkin: PropTypes.any,
};

export default StopCards;
